module.exports = __webpack_public_path__ + "static/media/Jennifer Bae.a3de815e.png";